import { HelpOutline } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import useDocumentationButtonStyles from './styles';
import { DocumentationButtonProps } from './types';
import { publicUrl } from 'kineticUtils/index';

const DocumentationButton: React.FunctionComponent<DocumentationButtonProps> = ({
  document = 'km_overview',
}) => {
  const { t } = useTranslation(['app', 'common']);
  const classes = useDocumentationButtonStyles();

  const openDocs = () => {
    window.open(publicUrl(`/help/kinetic_mobility/${document || 'km_overview'}.htm`));
  };

  const renderDocumentationButton = () => {
    return (
      <Tooltip title={t('documentation')}>
        <IconButton
          aria-label={t('documentation')}
          style={{ fontSize: 'inherit' }}
          onClick={() => openDocs()}
          className={classes.button}
        >
          <HelpOutline fontSize='small' />
        </IconButton>
      </Tooltip>
    );
  };

  return renderDocumentationButton();
};

export default DocumentationButton;
